export function contactsForm(){
    let contact_form = document.querySelector('.contacts-form .wpcf7');
    contact_form.addEventListener('wpcf7mailsent', function (event) {
        document.querySelector('.contacts-form').style.display = 'none';
        document.querySelector('.success-popup').style.display = 'block';
    }, false);

    $('.contacts-section .form-group.help').on('change', function () {
        $('.form-group.location').css('display', 'flex');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contactsForm.js